import Card from "@/components/Card";
import { faqArr } from "@/utils/StringUtils";
import ImageBanner from "@/components/ImageBanner";
import Footer from "@/layout/Footer";
function Faq() {
	return (
		<>
			<div className="relative flex flex-col hidden lg:flex w-full h-auto items-center justify-center mt-[40px]">
				<div className="w-full max-w-[1440px] flex items-center justify-between px-8">
					<ImageBanner
						type="desktop"
						title={`FAQ`}
						containerWidth="w-full max-w-[1440px] flex items-center"
						titlePosition={{ top: "top-[100px]", left: "left-[60px]" }}
					/>
				</div>
			</div>
			{/* Mobile View  */}
			<ImageBanner
				type="mobile"
				title={`FAQ`}
				mobileTitlePosition={{ top: "top-[180px]", left: "left-[10px]" }}
			/>
			<div className="max-w-3xl mx-auto px-4 py-8 space-y-4">
				{faqArr.map((item, index) => (
					<Card key={index} content={item} variant="privacy" />
				))}
			</div>
			<Footer />
		</>
	);
}

export default Faq;
